import { getNewGanttLibInstance } from './getNewGanttInstance';
import { initGantt } from './initGantt';
export default {
  getNewGanttLibInstance,
  initGantt
};
